/* @flow */
import React, { type Node } from 'react';
import Paper from 'material-ui/Paper';

const styles = {
  outer: {
    padding: 10,
  },
  inner: {
    padding: 10,
  },
};

type Props = {
  children: Node,
};

export default ({ children }: Props) => (
  <div style={styles.outer}>
    <Paper>
      <div style={styles.inner}>{children}</div>
    </Paper>
  </div>
);



// WEBPACK FOOTER //
// ./src/modules/components/Well.js